import { makeAutoObservable } from 'mobx';

import { User } from '../services/types/api.generated';

class SessionStore {
  user: User | null = null;

  csrfToken: string | null = null;

  isAuthenticated = false;
  isLoading = false;
  readonly USER_EMAIL_KEY = 'lastLoggedInUser';

  constructor() {
    makeAutoObservable(this);
  }

  setUser(user: User | null) {
    if (user && user.email && user.id) {
      localStorage.setItem(this.USER_EMAIL_KEY, user.email);
    } else {
      localStorage.removeItem(this.USER_EMAIL_KEY);
    }

    this.user = user;
    this.setIsAuthenticated(!!user);
    this.saveSession();
  }

  setIsAuthenticated(isAuthenticated: boolean) {
    this.isAuthenticated = isAuthenticated;
  }

  setCsrfToken(csrfToken: string | null) {
    this.csrfToken = csrfToken;
    this.saveSession();
  }

  setIsLoading(isLoading: boolean) {
    this.isLoading = isLoading;
  }

  saveSession() {
    if (this.user) {
      localStorage.setItem('user', JSON.stringify(this.user));
    } else {
      localStorage.removeItem('user');
    }

    if (this.csrfToken) {
      localStorage.setItem('csrfToken', this.csrfToken);
    } else {
      localStorage.removeItem('csrfToken');
    }
  }

  clearSession() {
    localStorage.removeItem(this.USER_EMAIL_KEY);
    this.setUser(null);
    this.setCsrfToken(null);
    this.setIsAuthenticated(false);
  }
}
const sessionStore = new SessionStore();
export default sessionStore;
